import React, { useEffect, useRef } from "react";
import "./SolutionsSection.css";

const SolutionsSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const updateConnector = () => {
      const section = sectionRef.current;
      if (!section) return;
      const connectorLine = section.querySelector(".solutions-connector-line");
      const solutionsTitle = section.querySelector(".solutions-title");
      const processTitle = document.querySelector(".process-title");
      if (!connectorLine || !solutionsTitle || !processTitle) return;

      const startRect = solutionsTitle.getBoundingClientRect();
      const endRect = processTitle.getBoundingClientRect();
      const sectionRect = section.getBoundingClientRect();

      // Position the connector line to span completely from Solutions to Process title
      const startY = startRect.bottom - sectionRect.top;
      const endY = sectionRect.height + (endRect.top - sectionRect.bottom);

      connectorLine.style.top = `${startY}px`;
      connectorLine.style.height = `${endY - startY}px`;
    };

    updateConnector();
    window.addEventListener("resize", updateConnector);
    window.addEventListener("scroll", updateConnector, { passive: true });
    return () => {
      window.removeEventListener("resize", updateConnector);
      window.removeEventListener("scroll", updateConnector);
    };
  }, []);

  return (
    <section id="services" ref={sectionRef} className="solutions-section">
      {/* Connector Line Background (spans to Process title) */}
      <div className="solutions-connector-line">
        <img src="/images/connector-line.png" alt="Connector Line" />
      </div>

      <div className="solutions-container">
        <h2 className="solutions-title">Solutions qui tiennent la route</h2>

        <p className="solutions-description">
          On ne se contente pas de "faire joli" ou de "coder vite". On conçoit
          des expériences, des marques et des produits digitaux qui donnent
          envie d'être utilisés… et qui tiennent la route sur le long terme.
        </p>

        <div className="solutions-grid">
          {/* Design UX/UI Card */}
          <div className="solution-card large-card">
            <div className="card-content">
              <div className="card-header">
                <div className="figma-icon-container">
                  <img src="/icons/figma.svg" alt="Figma" />
                </div>
                <h3 className="card-title">Design UX/UI</h3>
              </div>
              <p className="card-description">
                Des interfaces qui captent l'attention, fluidifient l'expérience
                et font oublier la technologie derrière.
              </p>
            </div>
            <button className="card-action-btn">
              <img src="/icons/arrow-right-up.svg" alt="Arrow Up" />
            </button>
          </div>

          {/* Branding Card */}
          <div className="solution-card medium-card">
            <div className="card-content">
              <div className="card-header">
                <div className="icon-container">
                  <img src="/icons/puncil.svg" alt="Branding" />
                </div>
                <h3 className="card-title">Branding</h3>
              </div>
              <p className="card-description">
                Une identité visuelle qui claque et qui dit exactement qui vous
                êtes, sans avoir à le répéter mille fois.
              </p>
            </div>
            <button className="card-action-btn">
              <img src="/icons/arrow-right-up.svg" alt="Arrow Up" />
            </button>
          </div>

          {/* Accompagnement tech Card */}
          <div className="solution-card medium-card">
            <div className="card-content">
              <div className="card-header">
                <div className="icon-container">
                  <img src="/icons/user.svg" alt="User" />
                </div>
                <h3 className="card-title">Accompagnement tech</h3>
              </div>
              <p className="card-description">
                On renforce vos équipes ou on sauve un projet en difficulté,
                sans tourner autour du pot.
              </p>
            </div>
            <button className="card-action-btn">
              <img src="/icons/arrow-right-up.svg" alt="Arrow Up" />
            </button>
          </div>

          {/* Développement Web & Mobile Card */}
          <div className="solution-card large-card">
            <div className="card-content">
              <div className="card-header">
                <div className="icon-container">
                  <img src="/icons/devweb.svg" alt="Développement Web" />
                </div>
                <h3 className="card-title">Developpement Web & Mobile</h3>
              </div>
              <p className="card-description">
                Des applis rapides, stables et prêtes à évoluer, construites
                comme si c'était les nôtres.
              </p>
            </div>
            <button className="card-action-btn">
              <img src="/icons/arrow-right-up.svg" alt="Arrow Up" />
            </button>
          </div>
        </div>

        {/* Tech Stack Stripe */}
        <div className="solutions-tech-stripe">
          <div className="tech-logos">
            <div className="tech-logo">
              <img src="/icons/flutter.svg" alt="Flutter" />
            </div>
            <div className="tech-logo">
              <img src="/icons/figma.svg" alt="Figma" />
            </div>
            <div className="tech-logo">
              <img src="/icons/n8n.svg" alt="N8N" />
            </div>
            <div className="tech-logo">
              <img src="/icons/typescript.svg" alt="TypeScript" />
            </div>
            <div className="tech-logo">
              <img src="/icons/tailwindcss.svg" alt="Tailwind CSS" />
            </div>
            <div className="tech-logo">
              <img src="/icons/js.svg" alt="JavaScript" />
            </div>
            <div className="tech-logo">
              <img src="/icons/nextjs.svg" alt="Next.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/nodejs.svg" alt="Node.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/framer.svg" alt="Framer" />
            </div>
            <div className="tech-logo">
              <img src="/icons/express.svg" alt="Express.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/wordpress.svg" alt="WordPress" />
            </div>
            {/* Duplicate logos for seamless infinite scrolling */}
            <div className="tech-logo">
              <img src="/icons/flutter.svg" alt="Flutter" />
            </div>
            <div className="tech-logo">
              <img src="/icons/figma.svg" alt="Figma" />
            </div>
            <div className="tech-logo">
              <img src="/icons/n8n.svg" alt="N8N" />
            </div>
            <div className="tech-logo">
              <img src="/icons/typescript.svg" alt="TypeScript" />
            </div>
            <div className="tech-logo">
              <img src="/icons/tailwindcss.svg" alt="Tailwind CSS" />
            </div>
            <div className="tech-logo">
              <img src="/icons/js.svg" alt="JavaScript" />
            </div>
            <div className="tech-logo">
              <img src="/icons/nextjs.svg" alt="Next.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/nodejs.svg" alt="Node.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/framer.svg" alt="Framer" />
            </div>
            <div className="tech-logo">
              <img src="/icons/express.svg" alt="Express.js" />
            </div>
            <div className="tech-logo">
              <img src="/icons/wordpress.svg" alt="WordPress" />
            </div>
          </div>
        </div>

        {/* Purple Background Div */}
        <div className="solutions-purple-bg"></div>
      </div>
    </section>
  );
};

export default SolutionsSection;
